import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase"; // ✅ Adjust this path as needed
import { useCart } from "../context/CartContext"; // if needed for cart merge

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
  e.preventDefault();

  const { email, password } = formData;

  try {
    await signInWithEmailAndPassword(auth, email, password);
    console.log("Logged in:", email);

    // ✅ Check if a redirect path is saved
    const redirectPath = localStorage.getItem("redirectAfterLogin") || "/products";
    localStorage.removeItem("redirectAfterLogin"); // clear it

    navigate(redirectPath);
  } catch (err) {
    setError("Login failed. Check your credentials.");
    console.error("Login error:", err);
  }
};


  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-br from-rose-50 to-white px-4 py-12">
      <div className="bg-white shadow-xl rounded-3xl w-full max-w-md p-8 sm:p-10">
        <h1 className="text-3xl font-bold text-rose-700 mb-6 text-center">
          Login to GlowAura
        </h1>

        {error && (
          <div className="bg-red-100 text-red-700 p-2 mb-4 rounded-md">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-rose-400"
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-1">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-rose-400"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-rose-600 hover:bg-rose-700 text-white py-2 rounded-md transition"
          >
            Login
          </button>
        </form>

        <p className="mt-6 text-sm text-center text-gray-600">
          Don’t have an account?{" "}
          <Link to="/signup" className="text-rose-600 hover:underline">
            Sign up
          </Link>
        </p>
      </div>
    </main>
  );
};

export default Login;
